const ApiKey = {
  GET_AGENT: 'roles',
  CREATE_QUOTE: 'quotes',
  GET_GATEWAYS: 'gateways',
  GET_HOTELS: 'hotels/list-by-dest-id',
  GET_DESTINATIONS: 'destinations/list-by-id',
  GET_DURATIONS: 'destinations/durations/list-by-gateway-destination',
  GET_DESTINATIONS_ONLY_HOTEL: 'destinations',
  DESTINATIONS: 'destinations',
  GATEWAY_DURATION: 'gateway-duration',
  GET_DURATIONS_ONLY_HOTEL: 'hotels/list-by-destination?destId=',
  GET_ROOMS: 'hotels/roomCategory',
  PROMOS: 'promotions',
  STATISTIC: 'quotes/statistic',
  ADMIN_STATISTIC: 'quotes/manual-quotes/statistic',
  ADMIN_REPORT_STATISTIC: 'quotes/report/statistic',
  REMINDER: 'reminders',
  GET_CRUISES: 'quotes/cruises/information',
  GET_NEW_CRUISES: 'cruises/destinations',
  GET_CRUISE_VENDOR: 'cruises/vendors',
  GET_CRUISE_SHIPS: 'cruises/ships',
  GET_CRUISE_SAILING: 'cruises/sailings',
  NOTE: '/notes',
  ACKNOWLEDGE: '/acknowledge',
  MY_QUOTE: 'quotes/my-quotes',
  ADMIN_QUOTE: 'quotes/manual-quotes',
  ADMIN_QUOTE_DETAILS: 'quotes',
  VIEW_QUOTE: 'quotes/',
  VIEW_MDT_QUOTE: 'mdt-quotes/',
  VIEW_CLIENT_COPPY: 'client-copy/',
  SUBMIT_CLIENT_COPY: 'client-copy',
  GET_AIR: 'airports?name=',
  GET_NEW_GATEWAY: 'gateways',
  LIST_FLIGHT: 'flight-info',
  GET_CURRENCY: 'currency',
  REPORT_QUOTE: 'quotes/report',
  AIR_PORTS: 'airports',
  HOTELS: 'hotels',
  SYNC_DATA: 'tasks/trigger',
  GATEWAY_AIRPORT_CODE: 'gateway-airport-code',
  TERM_CONDITIONS: 'term-conditions',
  CONFIG_FOR_URL: 'configurations/urls',
  CONFIG_FOR_URL_TYPE: 'configurations/urls/',
  EMAIL_CONFIG: 'expiry-configuration',
  DEPARTURE_CONFIG: 'departure-configuration',
  MAX_ROOMS_CONFIG: 'max-rooms',
  CHECK_MAX_ROOMS: 'check-max-rooms',
  UPDATE_QUOTE_STATUS: 'quotes/status',
  UPDATE_INTERNAL_STATUS: 'quotes/process',
  PAYMENT: 'quotes/payment',
  DEPARTURE_PORT: 'cruises/departure-ports',
  AIRLINE: 'airline',
  GET_HOTEL_ROOM_CATEGORY: 'hotels/hotelRoomCategory',
  FIND_FARE_REQUEST: 'flights/fares/search-by-flight',
  FLIGHT_INFORMATION: 'flights/search-flights-by-options',
  FLIGHT_INFORMATION_JAW: 'flights/search-flights-by-options-jaw',
  FLIGHT_INFORMATION_ONEWAY: 'flights/search-flights-by-options-one-way',
  CHARTER: 'flights/charter',
  EMAIL_URLS: 'configurations/urls/emails',
  VOUCHER_GET_LIST: 'quotes/vouchers',
  VOUCHER_EMAIL_CONFIG: 'configurations/templates/emails',
  OPTION_CONFIG: 'configurations/option-config',
  PREVIEW_VOUCHER: 'quotes/voucher/preview',
  SAVE_SIGNATURE: 'signatures',
  LIST_ROLE_PERMISSION: 'decentralization/role-permission',
  GENERATE_QUOTE_ID: 'quotes/generate-id',
  HCMS_ADMIN: 'quotes/hcms-admin',
  LAST_VISIT: 'quotes/last-visit',
  GROUP_TYPE: 'group-type',
  HOME_PAGE: 'home-page',
  MANAGE_CRUISE: 'admin/cruises',
  CRUISE: 'cruises',
  RULE_MANAGEMENT: 'rule-management',
  GET_PRICING_QUOTE: 'quotes',
  DESTINATION_GROUP: 'hotels/group-destination',
  AIRPORT_CODE: 'airports/list-for-management',
  FLIGHT_SEAT_INFORMATION: 'flights/search-flights-package',
  FLIGHT_ROUTE_EXCLUSION: 'flights/route/exclusion',
  GATE_DURATIONS: 'gateway-duration',
  SEARCH_ADDITIONAL: 'flights/fares/search-additional',
  FLIGHT_RULE: 'flight-rule',
  PREVIEW_FILE: 'preview-file',
  IMPORT_FILE: 'import-file',
  ADMINISTRATION: 'administration',
  URL_FILE: 'url-file',
  REVERT_FILE: 'revert-file',
  AIRLINE_TAX_LIST: 'airline-tax/list-management',
  AIRLINE_TAX: 'airline-tax',
  SEASONAL_CALENDAR: 'seasonal-calendar',
  AIR_PORT: 'airport',
  TOUR_COMBINATION: 'tour-combination',
  TOUR: 'tour',
  CITY: 'city',
  LIST_MANAGEMENT: 'list-management',
  TOUR_LIST_MANAGEMENT: 'tour/list-management',
  DELETE_TOUR_DETAIL: 'tour/delete',
  DELETE: 'delete',
  GET_NOTES: 'tour/get-notes',
  ADD_NOTE: 'tour/note',
  AUTO_SEARCH: 'tour/auto-search',
  ADD_DATA_AUTO_SEARCH: 'tour/auto-search/add',
  PREVIEW: 'preview',
  IMPORT: 'import',
  PACKAGE_ROOM_CATEGORY: 'package-room-category',
  HISTORY_LOG: 'admin-history-log',
  FILTER: 'filter',
  JAW: 'jaw',
  GATE_DEST_AIR: 'gate-dest-air',
  CHECK_JAW: 'check-route-exclusion',
  PACKAGE_RULE: 'package-rule',
  FILE: 'file/',
  PRE_SIGNED: 'pre-signed',
  SPECIAL_CONFIGURATION: 'special-configuration',
  NET_MARGIN: 'net-margin',
  AGENCY_BLACKLIST: 'agency-black-list',
  MIN_GROUP_SIZE: 'min-group-size',
  PRICE_SUMMARY: 'price-summary'
};

export default ApiKey;
